import { render, staticRenderFns } from "./ModalListPaysServicesComponent.vue?vue&type=template&id=8fefdcdc&scoped=true"
import script from "./ModalListPaysServicesComponent.vue?vue&type=script&lang=js"
export * from "./ModalListPaysServicesComponent.vue?vue&type=script&lang=js"
import style0 from "./ModalListPaysServicesComponent.vue?vue&type=style&index=0&id=8fefdcdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fefdcdc",
  null
  
)

export default component.exports